import React, { useState } from 'react';
import Tippy from '@tippyjs/react';
import InfoBubble from './InfoBubble';
import InfoPopup from './InfoPopup';
import { hideAll } from 'tippy.js';
import 'tippy.js/animations/scale-subtle.css';

const Hotspot = (props) => {
  const [active, setActive] = useState(false);
  const [referenceElement, setReferenceElement] = useState(null);

  const { x, y, cta_text, handleClick, ...sanitizedData } = props;

  const styles = {
    top: `calc(${y}% - 25px)`,
    left: `calc(${x}% - 25px)`,
    zIndex: active ? 30 : 1,
  };

  return (
    <div className="hotspot" style={styles}>
      <Tippy
        reference={referenceElement}
        content={<InfoPopup {...sanitizedData} cta_text={cta_text} />}
        animation={'scale-subtle'}
        interactive={true}
        placement={'bottom'}
        trigger="mouseenter focus click"
        onShow={(instance) => {
          hideAll({ exclude: instance });
          setActive(true);
        }}
        onHide={() => setActive(false)}
      />

      <span ref={setReferenceElement} style={{ display: 'inline-block' }}>
        <InfoBubble active={active} cta_text={cta_text} handleClick={handleClick} />
      </span>
    </div>
  );
};

export default Hotspot;
